import React from 'react';
import { connect } from 'react-redux';

import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { fixOnlyDateForTable } from '../../../../utils/format';
const TbodyTableMarcas = (props) => {
  const infoMarca = props.marca.marca;
  const { handleDeleteMarca, handleEdit } = props.actions;

  return (
    <tbody className="">
      {infoMarca.map((obj, index) => (
        <tr
          key={index}
          className="border-b">
          <td className="px-1 text-left">{obj.MARCA_ID}</td>
          <td className="px-1 text-left">{obj.MARCA_DESCRIPCION}</td>
          <td className="px-1 text-left">{fixOnlyDateForTable(obj.UPDATED_AT)}</td>
          <td className="px-1 text-left">{fixOnlyDateForTable(obj.CREATED_AT)}</td>
          <td className="">
            <PencilIcon
              className="h-5 w-5 transform cursor-pointer transition duration-300 hover:scale-110"
              onClick={() => handleEdit(obj)}
            />
          </td>
          <td className="">
            <TrashIcon
              className="h-5 w-5 transform cursor-pointer transition duration-300 hover:scale-110"
              onClick={() => handleDeleteMarca(obj.MARCA_ID)}
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const mapStateToProps = function (state) {
  return { marca: state.marca };
};

//export default Projects;
export default connect(mapStateToProps)(TbodyTableMarcas);
